module.exports = __webpack_public_path__ + "b72855f2b9b6746423a6dea209c1b045.png";